import { h, Component } from 'preact';
import { Text } from 'preact-i18n';

// Possible duplicates found by POST /api/parts/duplicate-check, shown in the
// "New part" drawer before the part is created.
class PartDuplicateList extends Component {
    useExisting = e => {
        const { onUse = () => {} } = this.props;
        const id = parseInt(e.currentTarget.dataset.id, 10);
        onUse(id);
    }

    render() {
        const {
            duplicates = [],
            aiChecked,
            busy,
            onCreateAnyway = () => {},
            onBack = () => {},
        } = this.props;

        return (
            <div class='mx-3 mb-3 part-duplicate-list'>
                <div class='alert alert-warning mb-2'>
                    <div class='fw-bold'>
                        <i class='fa-solid fa-triangle-exclamation me-2' />
                        <Text id='part.possible-duplicates'>Possible duplicates</Text>
                    </div>
                    <small class='d-block'>
                        <Text id='part.possible-duplicates-help'>These parts look like the one you are adding. Use the existing part, or create a new one anyway.</Text>
                    </small>
                    {!aiChecked && <small class='d-block mt-1 part-duplicate-not-ai'>
                        <i class='fa-solid fa-circle-info me-1' />
                        <Text id='part.duplicate-not-ai-checked'>Not checked by AI. These parts have the same identifier or name.</Text>
                    </small>}
                </div>
                <div class='list-group'>
                    {duplicates.map(dup => (
                        <div key={dup.id} class='list-group-item d-flex flex-row align-items-center part-duplicate-item'>
                            <div class='flex-fill me-2'>
                                <div>
                                    <strong>{dup.name}</strong>
                                    {aiChecked && <span class={`badge ms-2 part-duplicate-confidence ${dup.confidence === 'high' ? 'text-bg-danger' : 'text-bg-warning'}`}>
                                        {dup.confidence === 'high'
                                            ? <Text id='part.duplicate-high'>Likely duplicate</Text>
                                            : <Text id='part.duplicate-medium'>Possible duplicate</Text>}
                                    </span>}
                                    {dup.sold === true && <span class='badge text-bg-secondary ms-2'>
                                        <Text id='part.sold'>Sold</Text>
                                    </span>}
                                </div>
                                {!!(dup.brand || dup.model) && <small class='d-block text-body-secondary'>
                                    {[dup.brand, dup.model].filter(Boolean).join(' ')}
                                </small>}
                                {!!(dup.partNumber || dup.serialNumber || dup.regNumber) && <small class='d-block text-body-secondary'>
                                    {[dup.partNumber, dup.serialNumber, dup.regNumber].filter(Boolean).join(' · ')}
                                </small>}
                                {!!dup.reason && <small class='d-block mt-1 part-duplicate-reason'>
                                    <i class='fa-solid fa-sparkles me-1 text-body-secondary' />
                                    {dup.reason}
                                </small>}
                            </div>
                            <button
                                type='button'
                                class='btn btn-sm btn-outline-primary rounded-pill text-nowrap part-duplicate-use'
                                data-id={dup.id}
                                onClick={this.useExisting}
                                disabled={busy}
                            >
                                <Text id='part.use-existing'>Use this</Text>
                            </button>
                        </div>
                    ))}
                </div>
                <div class='d-flex flex-row mt-3'>
                    <button
                        type='button'
                        class='btn btn-outline-secondary rounded-pill me-2 part-duplicate-back'
                        onClick={onBack}
                        disabled={busy}
                    >
                        <Text id='part.back-to-editing'>Back to editing</Text>
                    </button>
                    <button
                        type='button'
                        class='btn btn-primary rounded-pill flex-fill part-duplicate-create'
                        onClick={onCreateAnyway}
                        disabled={busy}
                    >
                        {busy && <i class='fa-solid fa-spinner fa-spin me-2' />}
                        <Text id='part.create-anyway'>Create new anyway</Text>
                    </button>
                </div>
            </div>
        );
    }
}

export default PartDuplicateList;
